import React, {Component} from 'react';
import {connect} from 'react-redux';
import StyledButton from '../../cmp/themed/StyledButton';
import {FormattedMessage} from 'react-intl';
import OAuthSignIn from '../OAuthSignIn';
import RenderError from '../components/RenderError';
import {post, setAccessToken} from '../../../api';
import SponsorName from '../components/SponsorName';
import RecaptchaRenderer from '../../cmp/RecaptchaRenderer';
import dayjs from 'dayjs';
import {trimPostData, validateValueForInputMask} from '../../../tools/func';
import RenderFormInput from '../../cmp/formbuilder/RenderFormInput';
import {getItem} from '../../../tools/storage';

class AccountCreationForm extends Component {

    state = {

    }

    onChange = (key) => (e) => {
        this.setState({[key]: e.target.value});
    }


    handleFormSubmit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!this.shouldEnable()) {
            return;
        }
        if(this.state.password.length < 5){
            return this.setState({code:'Password should be at least 5 characters long'})
        }
        if (this.props.gtag_signup_conversion_id) {
            try {
                window.gtag('event', 'conversion', {
                    'send_to': this.props.gtag_signup_conversion_id,
                });
            } catch (e) {
            }
        }
        if(this.props.snapchat_pixel_id){
            try{
                window.snaptr('track','SIGN_UP')
            }catch(e){

            }
        }
        if (this.props.fb_signup_conversion_event) {
            try {
                window.fbq('track', this.props.fb_signup_conversion_event);
            } catch (e) {
            }
        }
        const postData = {};
        this.props.signupFields.forEach((item) => {
            if (item.isEnabled && this.state[item.id]) {
                postData[item.id] = this.state[item.id];
            }
        });
        this.setState({loading: true, code: null});
        const ref = this.state.ref || getItem('ref');
        const page_handle = this.props.page_handle;
        const utm_source = (getItem('utm_source') || page_handle);
        const toPost = trimPostData(postData);
        if(postData['date_of_birth']){
            toPost['date_of_birth'] = dayjs(postData['date_of_birth']).format('YYYY-MM-DD')
        }
        post('/register_new', {
            ...toPost,
            page_handle,
            ref,
            utm_source : utm_source ? ["undefined","null"].indexOf(utm_source) > -1 ? undefined : utm_source : undefined,
            recaptcha_response: this.state.recaptcha_response
        }).then((data) => {
            if (data.access_token) {
                setAccessToken(data.access_token)
                window.location = `/${this.props.isEmbedded ? '?embedded=1' : ''}`;
            } else {
                const {code} = data;
                this.setState({code, loading: false});
            }
        }).catch(() => {
            this.setState({loading: false});
        });
    }

    emailValidator = new RegExp(/\S+@\S+\.\S+/);


    shouldEnable = () => {
        const {email, password} = this.state;
        for (let x = 0; x < this.props.signupFields.length; x++) {
            const {id, isRequired, type, inputMask, isEnabled} = this.props.signupFields[x];
            const val = typeof this.state[id] === "string" ? this.state[id].trim() : this.state[id]
            if (isEnabled && isRequired && (!val || val.length === 0)) {
//                console.log('false for', id)
                return false;
            }
            if(id === "phone" && isRequired && isEnabled && val?.length < 7){
                return false;
            }
            // check for input mask
            if((!type || type === "text") && inputMask && String(inputMask).trim()){
                // validate input
                console.log({inputMask})
                if (!validateValueForInputMask(inputMask, val)) {
                    //                  console.log('false for mask', id)
                    return false;
                }
            }
        }
        return email && password
            && this.emailValidator.test(email)
            && (this.props.recaptcha_enabled ? this.state.recaptcha_response : true)
    }

    render() {
        if (!this.props.allow_partner_registrations) {
            return <p className="alert alert-danger"><FormattedMessage
                id={"We are not accepting registrations at this moment. Kindly check back later"}/></p>;
        }
        return (
            <div>
                {
                    this.state.code && <RenderError code={this.state.code}/>
                }
                <form onSubmit={this.handleFormSubmit}>
                    <div className={'row flex-wrap'}>
                        {
                            this.props.signupFields
                                .filter(({isEnabled}) => isEnabled)
                                .map((item, index) =>
                                    (<RenderFormInput key={item.id} {...item}
                                                value={this.state[item.id] || ""} onChange={this.onChange(item.id)}
                                    />))
                        }
                    </div>
                    {
                        this.props.recaptcha_enabled &&
                        <RecaptchaRenderer
                            onChange={this.onChange('recaptcha_response')}
                        />
                    }
                    <div className="d-flex justify-content-between align-items-center">
                        <div className={'d-flex align-items-center'}>
                            <StyledButton loading={this.state.loading} className={'btn btn-primary'} disabled={!this.shouldEnable()}
                                          onClick={this.handleFormSubmit}>
                                <FormattedMessage id={this.props.signupButtonText}/>
                            </StyledButton>
                            <SponsorName/>
                        </div>
                        <small className={'text-danger'}><FormattedMessage id={'required'}/></small>
                    </div>
                </form>
                <OAuthSignIn/>
            </div>
        );
    }
}


const defaultFieldsMap = [
    {
        label: 'Name',
        id: 'name',
        isRequired: false,
        isDefault: true,
        isEnabled: true
    },
    {
        label: 'Email',
        id: 'email',
        isRequired: true,
        isDefault: true,
        type: 'input',
        isEnabled: true
    },
    {
        label: 'Password',
        id: 'password',
        isRequired: true,
        isDefault: true,
        type: 'password',
        isEnabled: true
    }
];


function mapStateToProps(state, props) {
    const {isEmbedded, signupFields, signupPageTitle, signupButtonText} = props.page_data ? props.page_data : state.settings;
    return {
        recaptcha_enabled: state.settings.recaptcha_enabled,
        signupFields: signupFields ? JSON.parse(signupFields) : defaultFieldsMap,
        isEmbedded,
        mlm_show_referred_by: state.settings.mlm_show_referred_by,
        signupPageTitle: signupPageTitle || 'Create Account',
        signupButtonText: signupButtonText || 'Create Account',
        allow_partner_registrations: state.settings.allow_partner_registrations !== undefined ? state.settings.allow_partner_registrations : true,
        gtag_signup_conversion_id: state.settings.gtag_signup_conversion_id,
        fb_signup_conversion_event: state.settings.fb_signup_conversion_event || 'AccountCreated',
        snapchat_pixel_id: state.settings.snapchat_pixel_id
    };
}


export default connect(
    mapStateToProps
)(AccountCreationForm);
